// nodeStyles.js — Sistema de Diseño Unificado para Nodos del FlowBuilder
// Plan 1025 - Estandarización Visual 02-09-2026
// IMPORTAR en cada nodo: import { mkHeaderStyle, NODE_BODY_STYLE, NODE_INFO_ROW, mkHandleStyle } from "./nodeStyles";

// ─── HEADER ──────────────────────────────────────────────────────────────────
export const mkHeaderStyle = (color) => ({
  backgroundColor: color,
  backgroundImage: "linear-gradient(rgba(0,0,0,0.12), rgba(0,0,0,0.12))", // Filtro oscuro sutil
  color: "#ffffff",
  fontSize: "14px",
  fontWeight: "700",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "0 10px",
  height: "40px",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
  overflow: "hidden",
});

export const HEADER_ICON_STYLE = {
  width: "18px",
  height: "18px",
  color: "#ffffff",
  flexShrink: 0,
  filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.7))",
};

export const HEADER_TEXT_STYLE = {
  color: "#ffffff",
  fontSize: "14px",
  fontWeight: "700",
  letterSpacing: "0.3px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  flex: 1, 
  textShadow: "0px 1px 4px rgba(0,0,0,0.8)",
};

// ─── BODY ─────────────────────────────────────────────────────────────────────
export const NODE_BODY_STYLE = {
  padding: "12px",
  borderBottomLeftRadius: "10px",
  borderBottomRightRadius: "10px",
};

// ─── INFO ROW ────────────────────────────────────────────────────────────────
// Caja gris estándar para mostrar datos configurados dentro del nodo
export const NODE_INFO_ROW = {
  backgroundColor: "#f8fafc",
  borderRadius: "8px",
  padding: "8px 10px",
  border: "1px solid #e2e8f0",
  fontSize: "12px",
  color: "#334155",
  marginBottom: "0px",
  lineHeight: "1.4",
};

// ─── OUTPUT ROW ───────────────────────────────────────────────────────────────
// Fila de salida (label + handle)
export const OUTPUT_ROW_STYLE = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "6px 12px",
  margin: "0 -12px",
  borderTop: "1px solid #f1f5f9",
  position: "relative",
};

export const OUTPUT_LABEL_STYLE = {
  fontSize: "11px",
  color: "#64748b",
  fontWeight: "500",
};

// ─── HANDLES ─────────────────────────────────────────────────────────────────
export const mkHandleStyle = (color, overrides = {}) => ({
  background: color,
  width: "10px",
  height: "20px",
  borderRadius: "4px",
  border: "2px solid white",
  cursor: "pointer",
  ...overrides,
});

export const mkInputHandleStyle = (color) => mkHandleStyle(color, {
  left: "-12px",
  top: "20px",
});

export const mkOutputHandleStyle = (color) => mkHandleStyle(color, {
  right: "-12px",
  top: "50%", transform: "translateY(-50%)", zIndex: 1,
});

// ─── SECTION TITLE ────────────────────────────────────────────────────────────
// Para secciones dentro del body (ej: "OPCIONES", "TAREAS DE REMARKETING")
export const SECTION_TITLE_STYLE = {
  fontSize: "10px",
  fontWeight: "700",
  color: "#94a3b8",
  letterSpacing: "0.05em",
  textTransform: "uppercase",
  marginBottom: "0px",
  marginTop: "10px",
};
